module.exports = __webpack_public_path__ + "static/media/whichThinnerCost.a0f54e8a.mp3";